import { Profile } from '@/ts/store/profile';
import { RouteRecordRaw } from 'vue-router';

export const profile: Array<RouteRecordRaw> = [
  // profile
  {path: '/profile',  name: 'profile',  beforeEnter: [logged, initProfile], component: () => import('@/page/profile/index.vue'),
    children:[
      {path: 'start', name: 'profile/start', component: () => import('@/page/profile/onboarding/index.vue')},  
    ]
  },  
]


function logged(to: any, from: any, next: any) {
  console.log('router logged')
  const db = Profile()
  const profile: any = db.profile
  if (profile.id){
    next()
  } else{
    next({ name: 'home' })
  }
}

function initProfile(to: any, from: any, next: any) {
  const db = Profile()
  if (db.init && to.name !== 'profile/start'){
      next({ name: 'profile/start'})
      return
  }
  next()
}